import { render } from "./BaseModal.vue?vue&type=template&id=acca1f6a"
import script from "./BaseModal.vue?vue&type=script&lang=js"
export * from "./BaseModal.vue?vue&type=script&lang=js"

import "./BaseModal.vue?vue&type=style&index=0&id=acca1f6a&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/common/components/BaseModal/BaseModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "acca1f6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('acca1f6a', __exports__)) {
    api.reload('acca1f6a', __exports__)
  }
  
  module.hot.accept("./BaseModal.vue?vue&type=template&id=acca1f6a", () => {
    api.rerender('acca1f6a', render)
  })

}


export default __exports__